import { fromJS } from "immutable";

export default fromJS({
	breadcrumbsCount: 0,
	currentPage: 1,
	currentQuery: "",
	pageSize: 25,
	breadcrumbs: [],
	selectedUser: null,
	filters: {},
});
